import { CultureInfo } from '../culture-info.model';
import { CultureInfoTa } from './ta';

/**
 * @ignore
 */
export const CultureInfoTaSG: CultureInfo = {
  name: 'ta-SG',
  displayName: 'தமிழ் (சிங்கப்பூர்)',
  iso3LanguageCode: 'tam',
  iso2LanguageCode: 'ta',
  ietfLanguageTag: 'ta-SG',
  parent: CultureInfoTa
};
